import { Box, FormHelperText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import RewampUploadStatusRow from "./RewampUploadStatusRow";
import {
  fieldGridCellSx,
  FIELD_GRID_CONTROL_SX,
  FIELD_GRID_LABEL_SX,
  FIELD_GRID_LF_SPACER_SX,
  fieldGridFhSpacerSx,
  GRID_FH_SPACER_ATTR,
  GRID_FIELD_LABEL_ATTR,
  GRID_FIELD_STACK_ATTR,
  GRID_LF_SPACER_ATTR,
  LABEL_GAP,
} from "../formGrid";

export function RewampGridFieldStack({
  alignInGridRow = false,
  fillCell = true,
  label,
  control,
  helper,
}) {
  const theme = useTheme();

  if (!alignInGridRow) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: LABEL_GAP }}>
        {label}
        {control}
        {helper}
      </Box>
    );
  }

  return (
    <Box sx={fieldGridCellSx(fillCell)} {...{ [GRID_FIELD_STACK_ATTR]: "" }}>
      <Box sx={FIELD_GRID_LABEL_SX} {...{ [GRID_FIELD_LABEL_ATTR]: "" }}>
        {label}
      </Box>
      <Box sx={FIELD_GRID_LF_SPACER_SX} aria-hidden="true" {...{ [GRID_LF_SPACER_ATTR]: "" }} />
      <Box sx={FIELD_GRID_CONTROL_SX}>{control}</Box>
      <Box sx={fieldGridFhSpacerSx(theme, { fillCell })} {...{ [GRID_FH_SPACER_ATTR]: "" }}>
        {helper ?? null}
      </Box>
    </Box>
  );
}

RewampGridFieldStack.propTypes = {
  alignInGridRow: PropTypes.bool,
  fillCell: PropTypes.bool,
  label: PropTypes.node.isRequired,
  control: PropTypes.node.isRequired,
  helper: PropTypes.node,
};

export function RewampFieldHelperText({ message, id, tone }) {
  if (!message) return null;
  if (tone) return <RewampUploadStatusRow status={tone} message={message} id={id} />;
  return (
    <FormHelperText id={id} error sx={{ color: "formMessage.error", m: 0 }}>
      {message}
    </FormHelperText>
  );
}

RewampFieldHelperText.propTypes = {
  message: PropTypes.string,
  id: PropTypes.string,
  tone: PropTypes.oneOf(["info", "error", "success"]),
};
